import e, { useRef as R } from "react";
import { c as r, t as o } from "./app-a75c1d35.mjs";
import { I as v, a as b } from "./Image-d6406817.mjs";
import { V as k } from "./Video-232035c2.mjs";
import { W as x } from "./Icon-3122c134.mjs";
import { B } from "./Button-c598cb52.mjs";
import { B as d } from "./Block-9b78bd10.mjs";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
import "./useClickOutside-726e7c36.mjs";
const W = "hero-ratio", q = "article__hero-container", y = "desktop", P = "hero-ratio-without-quote", I = "article__hero-container--without-quote", w = "article__header", A = "article__header__no-buttons", D = "article__save-button", F = "article__save-button__svg", G = "button__icon", M = "article__hero-container__wrapper", O = "article__hero-container__wrapper__reference", V = "article__hero-container__wrapper__reference__text", j = "article__hero-container__no-sibling", z = "article__quote", J = "article__quote__light", K = "article__quote__text__dark__title", U = "article__quote__text__light__title", X = "article__quote__text__light__source", Y = "article__quote__text__light__ranking", Z = "article__leadText", $ = "article__description", t = {
  heroRatio: W,
  articleHeroContainer: q,
  desktop: y,
  heroRatioWithoutQuote: P,
  articleHeroContainerWithoutQuote: I,
  articleHeader: w,
  articleHeaderNoButtons: A,
  articleSaveButton: D,
  articleSaveButtonSvg: F,
  buttonIcon: G,
  articleHeroContainerWrapper: M,
  articleHeroContainerWrapperReference: O,
  articleHeroContainerWrapperReferenceText: V,
  articleHeroContainerNoSibling: j,
  articleQuote: z,
  articleQuoteLight: J,
  articleQuoteTextDarkTitle: K,
  articleQuoteTextLightTitle: U,
  articleQuoteTextLightSource: X,
  articleQuoteTextLightRanking: Y,
  articleLeadText: Z,
  articleDescription: $
};
function C(l) {
  const {
    quote: { field: s, title: n, source: _, ranking: g }
  } = l, a = s === "light", c = r(
    t.articleQuote,
    a && t.articleQuoteLight
  ), p = r({
    [o.textsLeadTextBold]: a,
    [t.articleQuoteTextLightTitle]: a,
    // Override light mode styling and typography with dark mode
    [o.textsLeadText]: !a,
    [t.articleQuoteTextDarkTitle]: !a
  });
  let m = "", i = "";
  return a && (m = r(
    o.textsLeadText,
    t.articleQuoteTextLightSource
  ), i = r(
    o.textsLeadTextBold,
    t.articleQuoteTextLightRanking
  )), /* @__PURE__ */ e.createElement(
    "div",
    {
      className: c,
      "data-testid": "article-page-hero-quote-container"
    },
    a ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("p", { className: i }, "#", g), /* @__PURE__ */ e.createElement("p", { className: p, itemProp: "description" }, n), /* @__PURE__ */ e.createElement("p", { className: m }, _)) : /* @__PURE__ */ e.createElement("p", { className: p, itemProp: "description" }, n)
  );
}
function me({ isSaved: l = !1, onClick: s }) {
  const n = l ? x.HEART_FILLED : x.HEART;
  return /* @__PURE__ */ e.createElement(
    B.IconLabel,
    {
      text: "Save",
      onClick: s,
      icon: {
        type: n,
        size: 16,
        className: t.articleSaveButtonSvg
      }
    }
  );
}
function ue(l) {
  const {
    assetType: s,
    heading: n,
    leadText: _,
    heroSource: g,
    imageReference: a,
    quote: c,
    hasIcons: p,
    description: m
  } = l, { displaySource: i, altText: T, mimeType: E, credits: f } = g, h = R(null), L = r(
    o.headingPage,
    t.articleHeader,
    p ? "" : t.articleHeaderNoButtons
  ), N = r(t.articleHeroContainer, {
    [t.articleHeroContainerWithoutQuote]: !c,
    [t.articleHeroContainerNoSibling]: !(h.current && h.current.nextElementSibling)
  }), H = r(
    o.textsCaption,
    t.articleHeroContainerWrapperReferenceText
  ), S = r(
    o.textsComponentTitleBold,
    t.articleLeadText
  ), Q = r(
    o.textsLeadText,
    t.articleDescription
  ), u = typeof i != "string";
  return /* @__PURE__ */ e.createElement("div", { className: "article", "data-testid": "article-page" }, /* @__PURE__ */ e.createElement(
    d,
    {
      topPadding: d.Padding.SMALL,
      bottomPadding: d.Padding.LARGE,
      "data-testid": "article-page-block"
    },
    /* @__PURE__ */ e.createElement(
      d.Content,
      {
        "data-testid": "article-page-block-content",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      /* @__PURE__ */ e.createElement("h1", { className: L, itemProp: "name" }, n),
      /* @__PURE__ */ e.createElement(
        "div",
        {
          className: N,
          ref: h,
          itemScope: !0,
          itemType: "https://schema.org/ImageObject"
        },
        s === "image" ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: t.articleHeroContainerWrapper }, /* @__PURE__ */ e.createElement(
          v,
          {
            src: u ? i.imageSrc : "",
            width: u ? i.width : 0,
            height: u ? i.height : 0,
            altText: T,
            imageLoader: u ? i.imageLoader : () => "",
            styling: b.ARTICLE_PAGE_HERO,
            "data-testid": "article-page-image",
            credits: f
          }
        ), a && /* @__PURE__ */ e.createElement(
          "div",
          {
            className: t.articleHeroContainerWrapperReference,
            "data-testid": "article-hero-image-reference"
          },
          /* @__PURE__ */ e.createElement(
            "p",
            {
              className: H,
              itemProp: "citation"
            },
            a
          )
        )), c && /* @__PURE__ */ e.createElement(C, { quote: c })) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
          k,
          {
            title: T,
            autoplay: !0,
            videoType: "asset",
            video: {
              src: u ? "" : i,
              mimeType: E
            },
            "data-testid": "article-page-video"
          }
        ), c && /* @__PURE__ */ e.createElement(C, { quote: c }))
      ),
      _ && /* @__PURE__ */ e.createElement("p", { className: S, itemProp: "description" }, _),
      m && /* @__PURE__ */ e.createElement(
        "div",
        {
          className: r(o.richText, Q),
          itemProp: "description"
        },
        m
      )
    )
  ));
}
export {
  ue as ArticlePageHero,
  me as SaveButton
};
//# sourceMappingURL=ArticlePageHero.js.map
